import React from 'react';
import { css } from '@emotion/core';

import { grid, twoColumnGrid, SPACE_COMPACT } from '@/styles';
import { FCC } from '@/utils/types';

import ItemHeader from '../item-header';

interface KeyValueProps {
  title: string;
  noPositionFix?: boolean;
}

const KVStyles = css`
  grid-template-columns: repeat(2, max-content);
  gap: ${SPACE_COMPACT}px;
  line-height: 1;
  align-items: center;

  &:last-child {
    margin-right: 0;
  }
`;

const KeyValue: FCC<KeyValueProps> = ({ title, noPositionFix, children, ...other }) => (
  <div css={[grid, twoColumnGrid, KVStyles]} {...other}>
    <ItemHeader noPositionFix={noPositionFix}>{title}</ItemHeader>
    {children}
  </div>
);

export default KeyValue;

export { default as CapabilityTier } from './capability-tier';
